import './style.scss'
import React from 'react'

export interface CheckboxProps {
    checked: boolean
    onChange: (checked: boolean) => void
    label?: React.ReactNode
    id?: string
    disabled?: boolean
    className?: string
}

export const Checkbox: React.FC<CheckboxProps> = ({
                                                      checked, onChange, label, id, disabled, className = '',
                                                  }) => (
    <label
        className={`checkbox ${disabled ? 'checkbox--disabled' : ''} ${className}`}
        htmlFor={id}
        style={{ display: 'inline-flex', alignItems: 'flex-start', gap: '0.9rem', width: '100%' }}
    >
        <input
            id={id}
            type="checkbox"
            checked={checked}
            disabled={disabled}
            onChange={(e) => onChange(e.target.checked)}
        />
        <span
            className="checkbox__box"
            style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
        >
            <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </span>
        {label && (
            <span className="checkbox__label" style={{ display: 'inline', flex: 1, minWidth: 0 }}>
                {label}
            </span>
        )}
    </label>
)

export default Checkbox